import {
  Button,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  mobileOnly,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

interface VoteButtonProps {
  vote: 'up' | 'down';
  onClick: VoidFunction;
}

export const VoteButton: React.FC<React.PropsWithChildren<VoteButtonProps>> = ({
  children,
  vote,
  onClick,
}) => {
  return (
    <StyledButton onClick={onClick} withBorder disableShadow type="secondary">
      <IconWithMargin
        size="S"
        asset={
          vote === 'up'
            ? GenericIconName.SmileyHappy
            : GenericIconName.SmileySad
        }
      />
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  padding: 20px 40px;
  flex-direction: column;
  font-weight: ${FONT_WEIGHTS.light};

  ${mobileOnly(
    css`
      flex-direction: row;
      text-align: left;
      padding: 20px;
    `,
  )}
`;

const IconWithMargin = styled(Icon)`
  margin-bottom: 10px;

  ${mobileOnly(
    css`
      margin-bottom: 0;
      margin-right: 10px;
    `,
  )}
`;
